export default function prepareAdvertising(advertisingList) {
  if (!Array.isArray(advertisingList)) return null;

  const now = new Date();

  const validAds = advertisingList.filter(ad => {
    const isForcedActive = ad.isActive === 1;

    const hasValidDateRange =
      (!ad.startDate || new Date(ad.startDate) <= now) &&
      (!ad.endDate || new Date(ad.endDate) >= now);

    return isForcedActive || hasValidDateRange;
  });

  if (!validAds.length) return null;

  validAds.sort((a, b) => {
    if (a.isActive !== b.isActive) return b.isActive - a.isActive;
    return new Date(b.startDate) - new Date(a.startDate);
  });

  const ad = validAds[0];

  return {
    id: ad.id,
    headline: ad.title,
    subline: ad.subtitle,
    content: ad.content,
    image: ad.imageUrl,

    startAt: ad.startDate,
    endAt: ad.endDate,

    isActive: true,
    delay: 3400
  };
}
